import { styled } from '@linaria/react';

export const ProductsListContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 1rem 0;

    @media (max-width: 768px) {
        padding: 1rem;
        flex: none;
        height: auto;
        min-height: auto;
        overflow: visible;
    }
`;

export const ProductsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.2rem;

    h2 {
        color: #333;
        margin: 0;
        font-size: 1.4rem;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }
`;

export const ViewToggle = styled.div`
    display: flex;
    background: #f8f9fa;
    border-radius: 6px;
    padding: 0.25rem;
    border: 1px solid #dee2e6;

    @media (max-width: 768px) {
        align-self: flex-end;
    }
`;

export const ViewButton = styled.button<{ $active?: boolean }>`
    background: none;
    border: none;
    padding: 0.4rem;
    border-radius: 4px;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: #495057;
        background: #e9ecef;
    }

    ${props => props.$active && `
        background: #6c757d;
        color: white;
    `}

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;

    p {
        color: #6c757d;
        font-size: 0.9rem;
    }
`;

export const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 4px solid #e3e3e3;
    border-top: 4px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    text-align: center;

    h3 {
        color: #dc3545;
        margin-bottom: 1rem;
    }

    p {
        color: #6c757d;
        margin-bottom: 1.5rem;
    }
`;

export const RetryButton = styled.button`
    background: #dc3545;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.3s;

    &:hover {
        background: #c82333;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 3rem;
    color: #6c757d;

    p {
        font-size: 0.9rem;
    }
`;

export const SearchSection = styled.div`
    margin-bottom: 1.2rem;
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    gap: 0.4rem;
    margin-bottom: 0.8rem;
`;

export const SearchInput = styled.input`
    flex: 1;
    padding: 0.5rem 0.8rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 0.8rem;
    background: white;

    &:focus {
        outline: none;
        border-color: #6c757d;
        box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.1);
    }
`;

export const FilterToggleBtn = styled.button<{ $active?: boolean }>`
    padding: 0.5rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f8f9fa;
        border-color: #6c757d;
    }

    ${props => props.$active && `
        background: #6c757d;
        color: white;
        border-color: #6c757d;
    `}

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const SearchOptions = styled.div`
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const SearchOptionsContainer = styled.div`
    /* Container for search options */
`;

export const SearchFieldsSection = styled.div`
    /* Search fields section */
`;

export const SectionLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    font-size: 0.8rem;
`;
export const CheckboxGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.75rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    color: #495057;
    font-size: 0.75rem;

    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    span {
        -webkit-user-select: none;
        user-select: none;
    }

    &:hover {
        color: #333;
    }
`;

export const ProductsListView = styled.div`
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 768px) {
        flex: none;
        height: auto;
        min-height: auto;
        overflow: visible;

        .list-header {
            grid-template-columns: 40px 1fr;

            .header-cell:not(.icon-header):not(.product-name-cell) {
                display: none;
            }
        }

        .list-row {
            grid-template-columns: 40px 1fr;
            cursor: pointer;

            .list-cell:not(.icon-cell):not(.product-name-cell) {
                display: none;
            }

            .product-name-cell {
                padding: 1rem;

                .product-regulation {
                    align-self: flex-start;
                }
            }
        }
    }
`;

export const ListHeader = styled.div`
    display: grid;
    grid-template-columns: 40px 2fr 2fr 1.5fr 1fr;
    background: rgb(238, 238, 238);
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;
`;

export const ListRowsContainer = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 768px) {
        flex: none;
        height: auto;
        min-height: auto;
        overflow: visible;
    }
`;

export const HeaderCell = styled.div`
    padding: 0.6rem;
    font-weight: 600;
    color: #495057;
    font-size: 0.7rem;
    text-transform: uppercase;
    border-right: 1px solid #dee2e6;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;

    &.icon-header {
        text-align: center;
        padding: 0.4rem;
    }

    &:last-child {
        border-right: none;
        text-align: center;
    }
`;

export const ListRow = styled.div<{ $clickable?: boolean }>`
    display: grid;
    grid-template-columns: 40px 2fr 2fr 1.5fr 1fr;
    border-bottom: 1px solid #f1f3f4;
    transition: background-color 0.2s;
    cursor: pointer;

    &:hover {
        background: #f8f9fa;
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const ListCell = styled.div`
    padding: 0.6rem;
    color: #495057;
    border-right: 1px solid #f1f3f4;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    font-size: 0.75rem;

    &:last-child {
        border-right: none;
        justify-content: center;
    }

    &.icon-cell {
        justify-content: center;
        padding: 0.4rem;

        .marpol-icon {
            width: 20px;
            height: 20px;
            display: block;
        }
    }

    &.product-name-cell {
        .product-name {
            font-weight: 600;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            font-size: 0.75rem;
        }
    }
`;

export const StatusBadge = styled.span<{ $active?: boolean }>`
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    font-size: 0.65rem;
    font-weight: 600;

    ${props => props.$active ? `
        background: #d4edda;
        color: #155724;
    ` : `
        background: #f8d7da;
        color: #721c24;
    `}
`;

export const ProductsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 1rem;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 1rem;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 1rem;
        flex: none;
        height: auto;
        min-height: auto;
        overflow: visible;
        padding: 0;
    }
`;

export const ProductCard = styled.div<{ $clickable?: boolean }>`
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;

    ${props => props.$clickable && `
        cursor: pointer;
    `}

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    @media (max-width: 768px) {
        padding: 1rem;
    }

    @media (max-width: 480px) {
        .product-header {
            flex-direction: column;
            align-items: flex-start;

            .product-regulation {
                margin-left: 0;
                margin-top: 0.5rem;
            }
        }
    }
`;

export const ProductHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.8rem;
`;

export const ProductName = styled.h3`
    color: #333;
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    flex: 1;
`;

export const ProductRegulation = styled.span`
    background: #667eea;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 1rem;
`;

export const ProductDetails = styled.div`
    margin-bottom: 1rem;
`;

export const ProductCategory = styled.p`
    color: #495057;
    margin: 0 0 0.75rem 0;
    font-size: 0.95rem;

    strong {
        color: #333;
    }
`;

export const ProductDescription = styled.p`
    color: #6c757d;
    font-size: 0.9rem;
    line-height: 1.4;
    margin: 0 0 0.75rem 0;
`;

export const ProductCodes = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const CodeBadge = styled.span`
    background: #f8f9fa;
    color: #495057;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    border: 1px solid #dee2e6;
`;

export const ProductFooter = styled.div`
    border-top: 1px solid #dee2e6;
    padding-top: 0.75rem;
`;

export const ProductDate = styled.small`
    color: #6c757d;
    font-size: 0.8rem;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
`;

export const PaginationButton = styled.button<{ $disabled?: boolean }>`
    padding: 6px 12px;
    border: 1px solid #dee2e6;
    background: ${props => props.$disabled ? '#f8f9fa' : '#ffffff'};
    color: ${props => props.$disabled ? '#adb5bd' : '#495057'};
    border-radius: 4px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    font-size: 0.875rem;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        background: #e9ecef;
        border-color: #adb5bd;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const PaginationInfo = styled.span`
    color: #495057;
    font-size: 0.875rem;
    padding: 0 8px;
`;

export const SearchLoadingIndicator = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid #e3e3e3;
    border-top: 2px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);

    @keyframes spin {
        0% { transform: translateY(-50%) rotate(0deg); }
        100% { transform: translateY(-50%) rotate(360deg); }
    }
`;